// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'blocks';

export const Component = () => (
  <path d='M24.521 0v6.848H0V0h24.521ZM.958.958V5.89h22.605V.958H.958ZM24.52 8.812v6.897H0V8.813h24.521ZM.958 9.819v4.885h22.605V9.818H.958ZM9.818 21.6v-1.005h11.781V21.6H9.818Zm-2.97-1.006h-2.92v-2.921H2.921v2.92H0V21.6h2.92v2.921h1.006V21.6h2.921v-1.006Z' />
);

export const viewBox = '0 0 25 25';
